import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { timer, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { PlatformService } from 'src/app/services/platform.service';
import { NotificationService } from 'src/app/services/notification.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  standalone: false
})
export class NotifyComponent implements OnInit, OnDestroy {
  public notifications: any[] = [];
  public itemsCount;
  public itemsFiltered;
  public itemsNotViewedCount: number;
  private notificationsSubscription: Subscription;
  private sessionReadySubscription: Subscription;

  constructor(
    public router: Router,
    private notifyProvider: NotificationService,
    private analyticsService: AnalyticsService,
    private platformService: PlatformService,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.updateNotifications();
    
    // Escuchar el evento de sesión lista para recargar notificaciones cuando el usuario haga login
    this.sessionReadySubscription = this.events.subscribe({ name: 'session', value: 'ready' }).subscribe(() => {
      console.log('Evento session:ready recibido en notify component, recargando notificaciones...');
      this.updateNotifications();
    });
  }

  ngOnDestroy() {
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }
    if (this.sessionReadySubscription) {
      this.sessionReadySubscription.unsubscribe();
    }
  }

  public openNotification(notification) {
    this.notifyProvider.openNotification(notification.action);
  }

  trackByFn(index, item) {
    return item.id;
  }

  private updateNotifications() {
    // Limpiar suscripción anterior si existe
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }

    const notifications$ = this.platformService.isMobile()
      ? this.notifyProvider.getNotifications()
      : timer(0, 20000).pipe(switchMap(() => this.notifyProvider.getNotifications()));

    this.notificationsSubscription = notifications$.subscribe({
      next: (res) => {
        this.notifications = res.items.itemList;
        this.itemsCount = res.items.itemsCount;
        this.itemsFiltered = res.items.itemsFiltered;
        this.itemsNotViewedCount = res.items.itemsNotViewedCount;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  public loadMore($event) {
    this.updateNotifications();
  }

  registerEventInAnalytics(notification) {
    const paramsToAnalytics = { actions: 2 };
    const name = notification.title;
    const id = notification.id;
    this.analyticsService.registerEvent(paramsToAnalytics, name, id);
  }
}
